import { handlePopupFormSubmit } from './utils/ajax-form-submit';
var hasUnsavedChanges = false;
var suppressUnsavedChangesWarning = false;
$('.ts-save-house-details').on('click', function () {
    suppressUnsavedChangesWarning = true;
    $('#house-details-form').submit();
});
$('.ts-reset-house-details').on('click', function () {
    var form = document.getElementById('house-details-form');
    form.reset();
    hasUnsavedChanges = false;
    //Reset input disable states
    $('.fn-secondary-component').find(':checkbox').prop('disabled', false);
    var chosenVariants = $('.fn-primary-component').find(':radio:checked');
    chosenVariants.each(function (i, radio) {
        var variantId = radio.value;
        $('.fn-secondary-component').find(':checkbox[value=' + variantId + ']').prop('disabled', true);
    });
});
$('.ts-delete-house-dialog-btn').on('click', function () {
    $('#delete-house-dialog').parent().addClass('visible');
});
$('.ts-delete-house-confirmation').on('change', function () {
    if (this.checked) {
        $('.ts-delete-house-dialog button[type="submit"]').removeAttr('disabled');
    }
    else {
        $('.ts-delete-house-dialog button[type="submit"]').attr('disabled', 'disabled');
    }
});
$('.ts-delete-house-dialog form').on('submit', function (e) {
    e.preventDefault();
    handlePopupFormSubmit($(this));
});
jQuery(function () {
    var dialog = document.getElementById('missing-editable-components-dialog');
    if (dialog) {
        $('#missing-editable-components-dialog').parent().addClass('visible');
    }
    var prevVariantId;
    function updateVariantSelection(event) {
        if (event !== null && event.target !== null) {
            var $radio = $(event.target);
            var $siblings = $radio.closest('.fn-primary-component').siblings('.fn-secondary-component');
            var variantId = $radio.val();
            var radiosToUpdate = $siblings.find(':checkbox[value=' + variantId + ']');
            var radiosToEnable = $siblings.find(':checkbox[value=' + prevVariantId + ']');
            radiosToUpdate.prop('disabled', true);
            radiosToEnable.prop('disabled', false);
        }
    }
    function setPreviousVariantId(event) {
        if (event !== null && event.target !== null) {
            var $radio = $(event.target);
            prevVariantId = $radio.closest('.fn-secondary-component, .fn-primary-component').find(':radio:checked').val().toString();
        }
    }
    function toggleSecondaryRow(event) {
        if (event !== null && event.target !== null) {
            var $componentSelection = $(event.target).closest('.fn-secondary-component');
            $componentSelection.find('.fn-checkbox-row').toggleClass('hidden');
            var images = $componentSelection.find('.fn-toggle-arrow');
            images.toggleClass('hidden');
        }
    }
    $('#house-details-form').on('change', function () {
        hasUnsavedChanges = true;
    });
    $(window).on('beforeunload', function () {
        if (hasUnsavedChanges && !suppressUnsavedChangesWarning) {
            return 'Du har gjort osparade ändringar på den här sidan. Är du säker på att du vill avbryta det?';
        }
    });
    $('.fn-primary-component .radio-box label').on('mouseup', setPreviousVariantId);
    $('.fn-primary-component .radio-box :radio').on('change', updateVariantSelection);
    $('.fn-toggle-checkbox-row').on('click', toggleSecondaryRow);
    $('.missing-editable-components__dialog').ready(function () {
        $('.vex-theme-mitthus .fn-primary-component .radio-box label').on('mouseup', setPreviousVariantId);
        $('.vex-theme-mitthus .fn-primary-component .radio-box :radio').on('change', updateVariantSelection);
        $('.vex-theme-mitthus .fn-toggle-checkbox-row').on('click', toggleSecondaryRow);
    });
});
